// source: wifi_config.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var constants_pb = require('./constants_pb.js');
goog.object.extend(proto, constants_pb);
var wifi_constants_pb = require('./wifi_constants_pb.js');
goog.object.extend(proto, wifi_constants_pb);
goog.exportSymbol('proto.espressif.CmdApplyConfig', null, global);
goog.exportSymbol('proto.espressif.CmdGetStatus', null, global);
goog.exportSymbol('proto.espressif.CmdSetConfig', null, global);
goog.exportSymbol('proto.espressif.RespApplyConfig', null, global);
goog.exportSymbol('proto.espressif.RespGetStatus', null, global);
goog.exportSymbol('proto.espressif.RespGetStatus.StateCase', null, global);
goog.exportSymbol('proto.espressif.RespSetConfig', null, global);
goog.exportSymbol('proto.espressif.WiFiConfigMsgType', null, global);
goog.exportSymbol('proto.espressif.WiFiConfigPayload', null, global);
goog.exportSymbol('proto.espressif.WiFiConfigPayload.PayloadCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.CmdGetStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.espressif.CmdGetStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.CmdGetStatus.displayName = 'proto.espressif.CmdGetStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.RespGetStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.espressif.RespGetStatus.oneofGroups_);
};
goog.inherits(proto.espressif.RespGetStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.RespGetStatus.displayName = 'proto.espressif.RespGetStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.CmdSetConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.espressif.CmdSetConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.CmdSetConfig.displayName = 'proto.espressif.CmdSetConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.RespSetConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.espressif.RespSetConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.RespSetConfig.displayName = 'proto.espressif.RespSetConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.CmdApplyConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.espressif.CmdApplyConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.CmdApplyConfig.displayName = 'proto.espressif.CmdApplyConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.RespApplyConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.espressif.RespApplyConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.RespApplyConfig.displayName = 'proto.espressif.RespApplyConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.espressif.WiFiConfigPayload = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.espressif.WiFiConfigPayload.oneofGroups_);
};
goog.inherits(proto.espressif.WiFiConfigPayload, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.espressif.WiFiConfigPayload.displayName = 'proto.espressif.WiFiConfigPayload';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.CmdGetStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.CmdGetStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.CmdGetStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.CmdGetStatus.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.CmdGetStatus}
 */
proto.espressif.CmdGetStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.CmdGetStatus;
  return proto.espressif.CmdGetStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.CmdGetStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.CmdGetStatus}
 */
proto.espressif.CmdGetStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.CmdGetStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.CmdGetStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.CmdGetStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.CmdGetStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.espressif.RespGetStatus.oneofGroups_ = [[10,11]];

/**
 * @enum {number}
 */
proto.espressif.RespGetStatus.StateCase = {
  STATE_NOT_SET: 0,
  FAIL_REASON: 10,
  CONNECTED: 11
};

/**
 * @return {proto.espressif.RespGetStatus.StateCase}
 */
proto.espressif.RespGetStatus.prototype.getStateCase = function() {
  return /** @type {proto.espressif.RespGetStatus.StateCase} */(jspb.Message.computeOneofCase(this, proto.espressif.RespGetStatus.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.RespGetStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.RespGetStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.RespGetStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.RespGetStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    staState: jspb.Message.getFieldWithDefault(msg, 2, 0),
    failReason: jspb.Message.getFieldWithDefault(msg, 10, 0),
    connected: (f = msg.getConnected()) && wifi_constants_pb.WifiConnectedState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.RespGetStatus}
 */
proto.espressif.RespGetStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.RespGetStatus;
  return proto.espressif.RespGetStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.RespGetStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.RespGetStatus}
 */
proto.espressif.RespGetStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.espressif.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {!proto.espressif.WifiStationState} */ (reader.readEnum());
      msg.setStaState(value);
      break;
    case 10:
      var value = /** @type {!proto.espressif.WifiConnectFailedReason} */ (reader.readEnum());
      msg.setFailReason(value);
      break;
    case 11:
      var value = new wifi_constants_pb.WifiConnectedState;
      reader.readMessage(value,wifi_constants_pb.WifiConnectedState.deserializeBinaryFromReader);
      msg.setConnected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.RespGetStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.RespGetStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.RespGetStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.RespGetStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getStaState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {!proto.espressif.WifiConnectFailedReason} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getConnected();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      wifi_constants_pb.WifiConnectedState.serializeBinaryToWriter
    );
  }
};


/**
 * optional Status status = 1;
 * @return {!proto.espressif.Status}
 */
proto.espressif.RespGetStatus.prototype.getStatus = function() {
  return /** @type {!proto.espressif.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.espressif.Status} value
 * @return {!proto.espressif.RespGetStatus} returns this
 */
proto.espressif.RespGetStatus.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional WifiStationState sta_state = 2;
 * @return {!proto.espressif.WifiStationState}
 */
proto.espressif.RespGetStatus.prototype.getStaState = function() {
  return /** @type {!proto.espressif.WifiStationState} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.espressif.WifiStationState} value
 * @return {!proto.espressif.RespGetStatus} returns this
 */
proto.espressif.RespGetStatus.prototype.setStaState = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional WifiConnectFailedReason fail_reason = 10;
 * @return {!proto.espressif.WifiConnectFailedReason}
 */
proto.espressif.RespGetStatus.prototype.getFailReason = function() {
  return /** @type {!proto.espressif.WifiConnectFailedReason} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.espressif.WifiConnectFailedReason} value
 * @return {!proto.espressif.RespGetStatus} returns this
 */
proto.espressif.RespGetStatus.prototype.setFailReason = function(value) {
  return jspb.Message.setOneofField(this, 10, proto.espressif.RespGetStatus.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.espressif.RespGetStatus} returns this
 */
proto.espressif.RespGetStatus.prototype.clearFailReason = function() {
  return jspb.Message.setOneofField(this, 10, proto.espressif.RespGetStatus.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.espressif.RespGetStatus.prototype.hasFailReason = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional WifiConnectedState connected = 11;
 * @return {?proto.espressif.WifiConnectedState}
 */
proto.espressif.RespGetStatus.prototype.getConnected = function() {
  return /** @type{?proto.espressif.WifiConnectedState} */ (
    jspb.Message.getWrapperField(this, wifi_constants_pb.WifiConnectedState, 11));
};


/**
 * @param {?proto.espressif.WifiConnectedState|undefined} value
 * @return {!proto.espressif.RespGetStatus} returns this
*/
proto.espressif.RespGetStatus.prototype.setConnected = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.espressif.RespGetStatus.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.espressif.RespGetStatus} returns this
 */
proto.espressif.RespGetStatus.prototype.clearConnected = function() {
  return this.setConnected(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.espressif.RespGetStatus.prototype.hasConnected = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.CmdSetConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.CmdSetConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.CmdSetConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.CmdSetConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    ssid: msg.getSsid_asB64(),
    passphrase: msg.getPassphrase_asB64(),
    bssid: msg.getBssid_asB64(),
    channel: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.CmdSetConfig}
 */
proto.espressif.CmdSetConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.CmdSetConfig;
  return proto.espressif.CmdSetConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.CmdSetConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.CmdSetConfig}
 */
proto.espressif.CmdSetConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSsid(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPassphrase(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBssid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChannel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.CmdSetConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.CmdSetConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.CmdSetConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.CmdSetConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSsid_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getPassphrase_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getBssid_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getChannel();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional bytes ssid = 1;
 * @return {!(string|Uint8Array)}
 */
proto.espressif.CmdSetConfig.prototype.getSsid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes ssid = 1;
 * This is a type-conversion wrapper around `getSsid()`
 * @return {string}
 */
proto.espressif.CmdSetConfig.prototype.getSsid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSsid()));
};


/**
 * optional bytes ssid = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSsid()`
 * @return {!Uint8Array}
 */
proto.espressif.CmdSetConfig.prototype.getSsid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSsid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.espressif.CmdSetConfig} returns this
 */
proto.espressif.CmdSetConfig.prototype.setSsid = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bytes passphrase = 2;
 * @return {!(string|Uint8Array)}
 */
proto.espressif.CmdSetConfig.prototype.getPassphrase = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes passphrase = 2;
 * This is a type-conversion wrapper around `getPassphrase()`
 * @return {string}
 */
proto.espressif.CmdSetConfig.prototype.getPassphrase_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPassphrase()));
};


/**
 * optional bytes passphrase = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPassphrase()`
 * @return {!Uint8Array}
 */
proto.espressif.CmdSetConfig.prototype.getPassphrase_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPassphrase()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.espressif.CmdSetConfig} returns this
 */
proto.espressif.CmdSetConfig.prototype.setPassphrase = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional bytes bssid = 3;
 * @return {!(string|Uint8Array)}
 */
proto.espressif.CmdSetConfig.prototype.getBssid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes bssid = 3;
 * This is a type-conversion wrapper around `getBssid()`
 * @return {string}
 */
proto.espressif.CmdSetConfig.prototype.getBssid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBssid()));
};


/**
 * optional bytes bssid = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBssid()`
 * @return {!Uint8Array}
 */
proto.espressif.CmdSetConfig.prototype.getBssid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBssid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.espressif.CmdSetConfig} returns this
 */
proto.espressif.CmdSetConfig.prototype.setBssid = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * optional int32 channel = 4;
 * @return {number}
 */
proto.espressif.CmdSetConfig.prototype.getChannel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.espressif.CmdSetConfig} returns this
 */
proto.espressif.CmdSetConfig.prototype.setChannel = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.RespSetConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.RespSetConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.RespSetConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.RespSetConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.RespSetConfig}
 */
proto.espressif.RespSetConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.RespSetConfig;
  return proto.espressif.RespSetConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.RespSetConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.RespSetConfig}
 */
proto.espressif.RespSetConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.espressif.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.RespSetConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.RespSetConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.RespSetConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.RespSetConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional Status status = 1;
 * @return {!proto.espressif.Status}
 */
proto.espressif.RespSetConfig.prototype.getStatus = function() {
  return /** @type {!proto.espressif.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.espressif.Status} value
 * @return {!proto.espressif.RespSetConfig} returns this
 */
proto.espressif.RespSetConfig.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.CmdApplyConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.CmdApplyConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.CmdApplyConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.CmdApplyConfig.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.CmdApplyConfig}
 */
proto.espressif.CmdApplyConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.CmdApplyConfig;
  return proto.espressif.CmdApplyConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.CmdApplyConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.CmdApplyConfig}
 */
proto.espressif.CmdApplyConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.CmdApplyConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.CmdApplyConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.CmdApplyConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.CmdApplyConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.RespApplyConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.RespApplyConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.RespApplyConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.RespApplyConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.RespApplyConfig}
 */
proto.espressif.RespApplyConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.RespApplyConfig;
  return proto.espressif.RespApplyConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.RespApplyConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.RespApplyConfig}
 */
proto.espressif.RespApplyConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.espressif.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.RespApplyConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.RespApplyConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.RespApplyConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.RespApplyConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional Status status = 1;
 * @return {!proto.espressif.Status}
 */
proto.espressif.RespApplyConfig.prototype.getStatus = function() {
  return /** @type {!proto.espressif.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.espressif.Status} value
 * @return {!proto.espressif.RespApplyConfig} returns this
 */
proto.espressif.RespApplyConfig.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.espressif.WiFiConfigPayload.oneofGroups_ = [[10,11,12,13,14,15]];

/**
 * @enum {number}
 */
proto.espressif.WiFiConfigPayload.PayloadCase = {
  PAYLOAD_NOT_SET: 0,
  CMD_GET_STATUS: 10,
  RESP_GET_STATUS: 11,
  CMD_SET_CONFIG: 12,
  RESP_SET_CONFIG: 13,
  CMD_APPLY_CONFIG: 14,
  RESP_APPLY_CONFIG: 15
};

/**
 * @return {proto.espressif.WiFiConfigPayload.PayloadCase}
 */
proto.espressif.WiFiConfigPayload.prototype.getPayloadCase = function() {
  return /** @type {proto.espressif.WiFiConfigPayload.PayloadCase} */(jspb.Message.computeOneofCase(this, proto.espressif.WiFiConfigPayload.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.espressif.WiFiConfigPayload.prototype.toObject = function(opt_includeInstance) {
  return proto.espressif.WiFiConfigPayload.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.espressif.WiFiConfigPayload} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.WiFiConfigPayload.toObject = function(includeInstance, msg) {
  var f, obj = {
    msg: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cmdGetStatus: (f = msg.getCmdGetStatus()) && proto.espressif.CmdGetStatus.toObject(includeInstance, f),
    respGetStatus: (f = msg.getRespGetStatus()) && proto.espressif.RespGetStatus.toObject(includeInstance, f),
    cmdSetConfig: (f = msg.getCmdSetConfig()) && proto.espressif.CmdSetConfig.toObject(includeInstance, f),
    respSetConfig: (f = msg.getRespSetConfig()) && proto.espressif.RespSetConfig.toObject(includeInstance, f),
    cmdApplyConfig: (f = msg.getCmdApplyConfig()) && proto.espressif.CmdApplyConfig.toObject(includeInstance, f),
    respApplyConfig: (f = msg.getRespApplyConfig()) && proto.espressif.RespApplyConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.espressif.WiFiConfigPayload}
 */
proto.espressif.WiFiConfigPayload.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.espressif.WiFiConfigPayload;
  return proto.espressif.WiFiConfigPayload.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.espressif.WiFiConfigPayload} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.espressif.WiFiConfigPayload}
 */
proto.espressif.WiFiConfigPayload.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.espressif.WiFiConfigMsgType} */ (reader.readEnum());
      msg.setMsg(value);
      break;
    case 10:
      var value = new proto.espressif.CmdGetStatus;
      reader.readMessage(value,proto.espressif.CmdGetStatus.deserializeBinaryFromReader);
      msg.setCmdGetStatus(value);
      break;
    case 11:
      var value = new proto.espressif.RespGetStatus;
      reader.readMessage(value,proto.espressif.RespGetStatus.deserializeBinaryFromReader);
      msg.setRespGetStatus(value);
      break;
    case 12:
      var value = new proto.espressif.CmdSetConfig;
      reader.readMessage(value,proto.espressif.CmdSetConfig.deserializeBinaryFromReader);
      msg.setCmdSetConfig(value);
      break;
    case 13:
      var value = new proto.espressif.RespSetConfig;
      reader.readMessage(value,proto.espressif.RespSetConfig.deserializeBinaryFromReader);
      msg.setRespSetConfig(value);
      break;
    case 14:
      var value = new proto.espressif.CmdApplyConfig;
      reader.readMessage(value,proto.espressif.CmdApplyConfig.deserializeBinaryFromReader);
      msg.setCmdApplyConfig(value);
      break;
    case 15:
      var value = new proto.espressif.RespApplyConfig;
      reader.readMessage(value,proto.espressif.RespApplyConfig.deserializeBinaryFromReader);
      msg.setRespApplyConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.espressif.WiFiConfigPayload.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.espressif.WiFiConfigPayload.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.espressif.WiFiConfigPayload} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.espressif.WiFiConfigPayload.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMsg();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCmdGetStatus();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.espressif.CmdGetStatus.serializeBinaryToWriter
    );
  }
  f = message.getRespGetStatus();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.espressif.RespGetStatus.serializeBinaryToWriter
    );
  }
  f = message.getCmdSetConfig();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.espressif.CmdSetConfig.serializeBinaryToWriter
    );
  }
  f = message.getRespSetConfig();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.espressif.RespSetConfig.serializeBinaryToWriter
    );
  }
  f = message.getCmdApplyConfig();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.espressif.CmdApplyConfig.serializeBinaryToWriter
    );
  }
  f = message.getRespApplyConfig();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.espressif.RespApplyConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional WiFiConfigMsgType msg = 1;
 * @return {!proto.espressif.WiFiConfigMsgType}
 */
proto.espressif.WiFiConfigPayload.prototype.getMsg = function() {
  return /** @type {!proto.espressif.WiFiConfigMsgType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.espressif.WiFiConfigMsgType} value
 * @return {!proto.espressif.WiFiConfigPayload} returns this
 */
proto.espressif.WiFiConfigPayload.prototype.setMsg = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional CmdGetStatus cmd_get_status = 10;
 * @return {?proto.espressif.CmdGetStatus}
 */
proto.espressif.WiFiConfigPayload.prototype.getCmdGetStatus = function() {
  return /** @type{?proto.espressif.CmdGetStatus} */ (
    jspb.Message.getWrapperField(this, proto.espressif.CmdGetStatus, 10));
};


/**
 * @param {?proto.espressif.CmdGetStatus|undefined} value
 * @return {!proto.espressif.WiFiConfigPayload} returns this
*/
proto.espressif.WiFiConfigPayload.prototype.setCmdGetStatus = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.espressif.WiFiConfigPayload.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.espressif.WiFiConfigPayload} returns this
 */
proto.espressif.WiFiConfigPayload.prototype.clearCmdGetStatus = function() {
  return this.setCmdGetStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.espressif.WiFiConfigPayload.prototype.hasCmdGetStatus = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional RespGetStatus resp_get_status = 11;
 * @return {?proto.espressif.RespGetStatus}
 */
proto.espressif.WiFiConfigPayload.prototype.getRespGetStatus = function() {
  return /** @type{?proto.espressif.RespGetStatus} */ (
    jspb.Message.getWrapperField(this, proto.espressif.RespGetStatus, 11));
};


/**
 * @param {?proto.espressif.RespGetStatus|undefined} value
 * @return {!proto.espressif.WiFiConfigPayload} returns this
*/
proto.espressif.WiFiConfigPayload.prototype.setRespGetStatus = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.espressif.WiFiConfigPayload.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.espressif.WiFiConfigPayload} returns this
 */
proto.espressif.WiFiConfigPayload.prototype.clearRespGetStatus = function() {
  return this.setRespGetStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.espressif.WiFiConfigPayload.prototype.hasRespGetStatus = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional CmdSetConfig cmd_set_config = 12;
 * @return {?proto.espressif.CmdSetConfig}
 */
proto.espressif.WiFiConfigPayload.prototype.getCmdSetConfig = function() {
  return /** @type{?proto.espressif.CmdSetConfig} */ (
    jspb.Message.getWrapperField(this, proto.espressif.CmdSetConfig, 12));
};


/**
 * @param {?proto.espressif.CmdSetConfig|undefined} value
 * @return {!proto.espressif.WiFiConfigPayload} returns this
*/
proto.espressif.WiFiConfigPayload.prototype.setCmdSetConfig = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.espressif.WiFiConfigPayload.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.espressif.WiFiConfigPayload} returns this
 */
proto.espressif.WiFiConfigPayload.prototype.clearCmdSetConfig = function() {
  return this.setCmdSetConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.espressif.WiFiConfigPayload.prototype.hasCmdSetConfig = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional RespSetConfig resp_set_config = 13;
 * @return {?proto.espressif.RespSetConfig}
 */
proto.espressif.WiFiConfigPayload.prototype.getRespSetConfig = function() {
  return /** @type{?proto.espressif.RespSetConfig} */ (
    jspb.Message.getWrapperField(this, proto.espressif.RespSetConfig, 13));
};


/**
 * @param {?proto.espressif.RespSetConfig|undefined} value
 * @return {!proto.espressif.WiFiConfigPayload} returns this
*/
proto.espressif.WiFiConfigPayload.prototype.setRespSetConfig = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.espressif.WiFiConfigPayload.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.espressif.WiFiConfigPayload} returns this
 */
proto.espressif.WiFiConfigPayload.prototype.clearRespSetConfig = function() {
  return this.setRespSetConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.espressif.WiFiConfigPayload.prototype.hasRespSetConfig = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional CmdApplyConfig cmd_apply_config = 14;
 * @return {?proto.espressif.CmdApplyConfig}
 */
proto.espressif.WiFiConfigPayload.prototype.getCmdApplyConfig = function() {
  return /** @type{?proto.espressif.CmdApplyConfig} */ (
    jspb.Message.getWrapperField(this, proto.espressif.CmdApplyConfig, 14));
};


/**
 * @param {?proto.espressif.CmdApplyConfig|undefined} value
 * @return {!proto.espressif.WiFiConfigPayload} returns this
*/
proto.espressif.WiFiConfigPayload.prototype.setCmdApplyConfig = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.espressif.WiFiConfigPayload.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.espressif.WiFiConfigPayload} returns this
 */
proto.espressif.WiFiConfigPayload.prototype.clearCmdApplyConfig = function() {
  return this.setCmdApplyConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.espressif.WiFiConfigPayload.prototype.hasCmdApplyConfig = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional RespApplyConfig resp_apply_config = 15;
 * @return {?proto.espressif.RespApplyConfig}
 */
proto.espressif.WiFiConfigPayload.prototype.getRespApplyConfig = function() {
  return /** @type{?proto.espressif.RespApplyConfig} */ (
    jspb.Message.getWrapperField(this, proto.espressif.RespApplyConfig, 15));
};


/**
 * @param {?proto.espressif.RespApplyConfig|undefined} value
 * @return {!proto.espressif.WiFiConfigPayload} returns this
*/
proto.espressif.WiFiConfigPayload.prototype.setRespApplyConfig = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.espressif.WiFiConfigPayload.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.espressif.WiFiConfigPayload} returns this
 */
proto.espressif.WiFiConfigPayload.prototype.clearRespApplyConfig = function() {
  return this.setRespApplyConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.espressif.WiFiConfigPayload.prototype.hasRespApplyConfig = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * @enum {number}
 */
proto.espressif.WiFiConfigMsgType = {
  TYPECMDGETSTATUS: 0,
  TYPERESPGETSTATUS: 1,
  TYPECMDSETCONFIG: 2,
  TYPERESPSETCONFIG: 3,
  TYPECMDAPPLYCONFIG: 4,
  TYPERESPAPPLYCONFIG: 5
};

goog.object.extend(exports, proto.espressif);
